import { mobileQuery, wideQuery, desktopQuery, smallQuery, tabletQuery, DIMENSION, ultrawideQuery } from '../constants';
import { useMediaQuery } from './useMediaQuery';

const useResponsive = () => {
    const isMobile = useMediaQuery({
        query: mobileQuery,
    });

    const isWide = useMediaQuery({
        query: wideQuery,
    });

    const isDesktop = useMediaQuery({
        query: desktopQuery,
    });

    const isSmall = useMediaQuery({
        query: smallQuery,
    });

    const isTablet = useMediaQuery({
        query: tabletQuery,
    });

    const isUltraWide = useMediaQuery({
        query: ultrawideQuery,
    });

    let dimension = DIMENSION.DESKTOP;

    if (isSmall) {
        dimension = DIMENSION.SMALL;
    }

    if (isMobile) {
        dimension = DIMENSION.MOBILE;
    }

    if (isTablet) {
        dimension = DIMENSION.TABLET;
    }

    if (isWide) {
        dimension = DIMENSION.WIDE;
    }

    if (isUltraWide) {
        dimension = DIMENSION.ULTRAWIDE;
    }

    return { isMobile, isWide, isDesktop, isSmall, isTablet, isUltraWide, dimension };
};

export { useResponsive };
